import { catalogInlineSearchConstants } from '../constants'

const initialState = {
    search: '',
    contentType: '',
    language: '',
    sortBy: '',
    integratedOnly: false,
}

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case catalogInlineSearchConstants.CHANGE:
            return {
                ...state,
                ...action.params,
            }
        case catalogInlineSearchConstants.RESET:
            return {
                ...initialState,
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/reducers/catalogInlineSearch.js